import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { currentUserSelector } from '../../../reducers/users';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import NavBarNew from './NavBarNew';

const NavBarNewContainerSelector = immutableCreatorSelector(
  [currentUserSelector],
  currentUser => ({
    currentUser,
  }),
);

@connect(NavBarNewContainerSelector)
class NavBarNewContainer extends React.Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  render() {
    const { dispatch, currentUser } = this.props;
    return <NavBarNew dispatch={dispatch} currentUser={currentUser} />;
  }
}

export default NavBarNewContainer;



// WEBPACK FOOTER //
// ./src/components/toolbars/NavBarNew/NavBarNewContainer.js